import { Component } from '@angular/core';
import { Price } from '../../../shared/price-selection/model/price.class'
import { Item } from '../../../shared/listbox/model/item.class';

@Component({
  selector: 'app-pesquisa-salarial-assinatura',
  templateUrl: './pesquisa-salarial-assinatura.component.html',
  styleUrls: ['./pesquisa-salarial-assinatura.component.css']
})
export class PesquisaSalarialAssinaturaComponent {
  listOne: Item[] = [
    {
      id: 1,
      name: 'São Paulo',
      subItens: [
        {
          id: 1200013,
          name: "ACRELÂNDIA",
          idMicrorregiao: 12004,
          listaDsMicrorregiao: [
            "ACRELÂNDIA",
            "BUJARI",
            "CAPIXABA",
            "PLÁCIDO DE CASTRO",
            "RIO BRANCO",
            "SENADOR GUIOMARD",
            "PORTO ACRE",
          ]
        },
        { id: 11, name: 'Santo André', idMicrorregiao: 1, listaDsMicrorregiao: ['Teste 1', 'Teste2'] },
        { id: 12, name: 'Campinas', idMicrorregiao: 1, listaDsMicrorregiao: ['Teste 1', 'Teste2'] },
        { id: 13, name: 'Santos', idMicrorregiao: 1 , listaDsMicrorregiao: ['Teste 1', 'Teste2'] },
        { id: 31, name: 'Rio Grande da Serra', idMicrorregiao: 1, listaDsMicrorregiao: ['Teste 1', 'Teste2']  },
        { id: 32, name: 'São Caetano do Sul', idMicrorregiao: 1, listaDsMicrorregiao: ['Teste 1', 'Teste2']  },
        { id: 33, name: 'Bauru', idMicrorregiao: 1, listaDsMicrorregiao: ['Teste 1', 'Teste2']  },
        { id: 34, name: 'São Bernardo', idMicrorregiao: 1, listaDsMicrorregiao: ['Teste 1', 'Teste2']  },
        { id: 35, name: 'Barueri', idMicrorregiao: 1, listaDsMicrorregiao: ['Teste 1', 'Teste2']  },
        { id: 36, name: 'Osasco', idMicrorregiao: 1, listaDsMicrorregiao: ['Teste 1', 'Teste2']  },
        { id: 37, name: 'Americana', idMicrorregiao: 1, listaDsMicrorregiao: ['Teste 1', 'Teste2']  },
        { id: 38, name: 'Mirassol', idMicrorregiao: 1, listaDsMicrorregiao: ['Teste 1', 'Teste2']  },
        { id: 39, name: 'Diadema', idMicrorregiao: 1, listaDsMicrorregiao: ['Teste 1', 'Teste2']  },
      ]
    },
    {
      id: 2,
      name: 'Rio de Janeiro',
      subItens: [
        { id: 4, name: 'Cabo Frio', idMicrorregiao: 2, listaDsMicrorregiao: ['Teste 3', 'Teste 4'] },
        { id: 5, name: 'Niterói', idMicrorregiao: 2, listaDsMicrorregiao: ['Teste 3', 'Teste 4'] },
        { id: 6, name: 'Volta Redonda', idMicrorregiao: 2, listaDsMicrorregiao: ['Teste 3', 'Teste 4'] }
      ]
    },
    {
      id: 3,
      name: 'Minas Gerais',
      subItens: [
        { id: 7, name: 'Belo Horizonte', idMicrorregiao: 3, listaDsMicrorregiao: ['Teste 5', 'Teste 5'] },
        { id: 8, name: 'Ouro Preto', idMicrorregiao: 3, listaDsMicrorregiao: ['Teste 5', 'Teste 5'] },
        { id: 9, name: 'Juiz de Fora', idMicrorregiao: 3, listaDsMicrorregiao: ['Teste 5', 'Teste 5'] }
        
      ]
    }
  ];
  listTwo: Item[] = [];

  meusPrecos: Price[] = 
    [
      {
        id: 1,
        descricao: "1 mês",
        descricaoValor: "R$ 1.350,00",
        valor: 1350,
        melhorOferta: false,
      },
      {
        id: 2,
        descricao: "6 meses",
        descricaoValor: "R$ 6.750,00",
        valor: 6750,
        melhorOferta: false,
      },
      {
        id: 3,
        descricao: "12 meses",
        descricaoValor: "R$ 10.800,00",
        valor: 10800,
        melhorOferta: true,
      },
    ];
  
  onPriceSelected(price: Price) {
    console.log('Preço selecionado:', price);
    // Lógica para lidar com a seleção do preço aqui
  }

  onListOneSelected(itens: Item[]) {
    this.listOne = itens;
    console.log('Lista 2 atualizada recebida:', this.listOne);
  }

  onListTwoSelected(itens: Item[]) {
    this.listTwo = itens;
    console.log('Lista 2 atualizada recebida:', this.listTwo);
  }
}
